module.exports = __webpack_public_path__ + "static/images/containers/ShopView/containers/ShopCongratulationScreen/images/highlight.b733d0dc.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/containers/ShopCongratulationScreen/images/highlight.png
// module id = 3259
// module chunks = 11